import baseService from '../shared/baseService';

const clientProductService = (clientId: number) =>
    baseService(`clients/${clientId}/products`);

export default { 
    clientProductService
};

